import { useEffect, useState } from "react";
import MesonetClimateLayout from "../../component/MesonetClimateLayout";
import { Autocomplete, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from "@mui/material";
import ClimateChart from "../../component/ClimateChart";
import moment from "moment-timezone";

export default function MesonetClimateGraphs() {
    const [site, setSite] = useState("FARM");
    const [options, setOptions] = useState([]);
    const [selectedYear, setSelectedYear] = useState(2026);
    const [availableYears, setAvailableYears] = useState([]);
    const yearOptions = availableYears.length > 0 ? availableYears : [];

    useEffect(() => {
        fetch("/api/getStationsInfo")
            .then(res => res.json())
            .then(json => {
                const x = Object.entries(json)
                    .map(([key]) => {
                        const item = json[key];
                        if (
                            !item.isDiscontinued &&
                            moment().startOf("day").diff(
                                moment(item.dateEstablished, "YYYY-MM-DD HH:mm:ss"),
                                "days"
                            ) >= (3 * 365) + 1
                        ) {
                            return {
                                label: `${item.county} County (${key})`,
                                value: key
                            };
                        }
                        return null;
                    })
                    .filter(Boolean)
                    .sort((a, b) => a.label.localeCompare(b.label));

                setOptions(x);
                const firstSite = x[0];
                setSite(firstSite);
                // Fetch available years for the first site
                if (firstSite?.value) {
                    fetch(`/api/getAvailableYears/${firstSite.value}`)
                        .then(res => res.json())
                        .then(data => {
                            setAvailableYears(data.years || []);
                            // Set selected year to the most recent available year
                            if (data.years && data.years.length > 0) {
                                setSelectedYear(data.years[0]);
                            }
                        })
                        .catch(err => console.error("Failed to fetch available years:", err));
                }
            });
    }, []);

    // Fetch available years when site changes
    useEffect(() => {
        const siteKey = typeof site === "string" ? site : site?.value;
        if (siteKey) {
            fetch(`/api/getAvailableYears/${siteKey}`)
                .then(res => res.json())
                .then(data => {
                    setAvailableYears(data.years || []);
                    // If current selected year is not available, select the most recent
                    if (data.years && data.years.length > 0) {
                        if (!data.years.includes(selectedYear)) {
                            setSelectedYear(data.years[0]);
                        }
                    }
                })
                .catch(err => console.error("Failed to fetch available years:", err));
        }
    }, [site]);

    return (
        <MesonetClimateLayout activeTab={0}>
            <Stack direction={{ xs: "column", md: "row" }} spacing={2} sx={{ mb: 2 }}>
                <Autocomplete
                    options={options}
                    renderInput={(params) => (
                        <TextField {...params} label="Stations" />
                    )}
                    onChange={(event, newValue) => setSite(newValue)}
                    value={site}
                    disableClearable
                    sx={{ flex: 1 }}
                />
                <FormControl sx={{ minWidth: { xs: "100%", md: 260 } }}>
                    <InputLabel id="climate-year-label">Year</InputLabel>
                    <Select
                        labelId="climate-year-label"
                        id="climate-year"
                        value={selectedYear}
                        label="Year"
                        onChange={(event) => setSelectedYear(Number(event.target.value))}
                    >
                        {yearOptions.map((year) => (
                            <MenuItem key={year} value={year}>{year}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Stack>
            <ClimateChart
                site={site}
                year={selectedYear}
                key={`${site?.value || site}-${selectedYear}`}
            />
        </MesonetClimateLayout>
    );
}
